<template>
    <div>
        <!-- <div style="position: relative;">
            <img src="@/images/homeImg.png" style="width: 100vw;height: 30.21vw;">
            <div class="topTitle">
                见心即安心
            </div>
            <div class="topText">
                您的情绪管理帮办！心理装备专家！
            </div>
        </div> -->
        <swiperCom></swiperCom>
        <div class="TitleCss" style="margin-bottom:1.56vw">
            <div style="margin-bottom:0.52vw;padding-top:4.45vw;">
                关于见心
            </div>
            <div style="font-weight: 400;font-size: 0.73vw;color: #7ED0FF;">
                About FOHEART
            </div>
        </div>
        <div class="jianxinCss">
            <img src="@/images/homeImg1.png" style="width: 33.85vw;height: 22.6vw;margin-right:2.6vw ;">
            <div style="min-height: 22.6vw;width: 36.2vw;">
                <div>
                    湖南见心科技有限公司专注于心理健康领域的整体解决方案，包括产品研发、销售、人才培训以及社会服务。我们力求让每个人都能轻松获得科学的心理健康支持。
                    我们的主要客户是学校。我们为学校提供全面的心理健康服务体系，帮助学生们培养积极的心态。此外，我们也为社区、医院、公安部队等机构提供专业的心理健康服务，服务网络遍布全国。
                    我们坚信预防和干预同等重要。因此，我们不仅关注问题的解决，也注重心理健康的普及与教育。我们不断创新，开发新的技术和产品，推动心理健康行业的发展。
                    我们有一支专门的心理软件研发队伍，并与经验丰富的心理学专家和一线教师合作，将先进的心理科学转化为实际可用的产品和服务。我们始终关注客户的需求，提供专业、高效且可靠的心理健康解决方案，助力各个领域提升心理健康水平。
                </div>
                <div class="btn1" @click="toGO">
                    了解更多
                </div>
            </div>
        </div>
        <div style="height: 50.94vw;background-color: #0093E8;text-align: center;">
            <div class="TitleCss" style="margin-bottom:1.56vw;padding-top:4.81vw">
                <div style="margin-bottom:0.52vw;color: #fff;">
                    业务范畴
                </div>
                <div style="font-weight: 400;font-size: 0.73vw;color: #fff;">
                    Business scope
                </div>
            </div>
            <div class="box2Css">
                <div class="boxOneCss">
                    <img src="@/images/homeImg2.png" style="width: 8.23vw;height: 5.16vw;margin-top: 4.16vw;">
                    <div style="margin-top: 3.18vw;margin-bottom: 3.18vw;">心理健康产品开发</div>
                    <div class="boxOneText">
                        1.开发基于最新心理学研究成果的应用软件和服务平台，旨在提高心理健康意识，提供有效的心理辅导工具。<br>
                        2.创新性地运用人工智能技术进行情绪识别与分析，为用户提供个性化的心理健康建议。
                    </div>
                </div>
                <div class="boxOneCss">
                    <img src="@/images/homeImg3.png" style="width: 8.23vw;height: 5.16vw;margin-top: 4.16vw;">
                    <div style="margin-top: 1.35vw;margin-bottom: 3.18vw;">心理健康<br>
                        服务体系构建</div>
                    <div class="boxOneText">
                        1.针对学校环境设计心理健康教育课程，促进学生心理健康发展。<br>
                        2.提供心理健康筛查、评估及早期干预服务，帮助识别潜在的心理健康问题。
                    </div>
                </div>
                <div class="boxOneCss">
                    <img src="@/images/homeImg4.png" style="width: 8.23vw;height: 5.16vw;margin-top: 4.16vw;">
                    <div style="margin-top: 3.18vw;margin-bottom: 3.18vw;">专业人才培训</div>
                    <div class="boxOneText">
                        1.组织心理健康教育培训项目，提升教师及其他从业人员的专业技能。<br>
                        2.开展心理健康工作坊和研讨会，分享最新的研究进展与实践案例。
                    </div>
                </div>
                <div class="boxOneCss">
                    <img src="@/images/homeImg5.png" style="width: 8.23vw;height: 5.16vw;margin-top: 4.16vw;">
                    <div style="margin-top: 3.18vw;margin-bottom: 3.18vw;">社会化服务</div>
                    <div class="boxOneText">
                        1.在社区、医院和公安部队等不同场景下推广心理健康知识，增强公众的心理健康素养。<br>
                        2.通过线上线下相结合的方式，提供心理咨询和支持服务，覆盖更广泛的人群。
                    </div>
                </div>
            </div>
        </div>
        <div style="background-color: #f0f6fa;text-align: center;padding-bottom: 3.083vw;">
            <div class="TitleCss" style="margin-bottom:1.56vw;padding-top:4.81vw;">
                <div style="margin-bottom:0.52vw;">
                    公司优势
                </div>
                <div style="font-weight: 400;font-size: 0.73vw;color: #7ED0FF;">
                    Company advantages
                </div>
            </div>
            <div class="box2Css">
                <div style="position: relative;">
                    <img src="@/images/honeYou1.png" style="width: 38.49vw;height: 14.95vw;">
                    <div class="boxTwoCss">
                        <div class="boxTitleCss">科学研究与验证</div>
                        <div>
                            我们的产品基于严格的心理学研究和临床验证，确保每一种疗愈手段都有科学依据。
                        </div>
                    </div>
                </div>
                <div style="position: relative;">
                    <img src="@/images/honeYou2.png" style="width: 38.49vw;height: 14.95vw;">
                    <div class="boxTwoCss">
                        <div class="boxTitleCss">系统化与标准化</div>
                        <div>
                            我们提供系统化和标准化的产品，确保每个步骤都有明确的目标和结果。<br> 每种疗愈手段都有详细的适用人群指导，确保精准匹配。
                        </div>
                    </div>
                </div>
                <div style="position: relative;">
                    <img src="@/images/honeYou3.png" style="width: 38.49vw;height: 14.95vw;">
                    <div class="boxTwoCss">
                        <div class="boxTitleCss">专业团队支持</div>
                        <div>
                            我们拥有一支由心理学专家和技术研发人员组成的精英团队，确保每项服务的专业性和有效性。<br> 团队成员具备丰富的理论与实践经验，能够为
                        </div>
                    </div>
                </div>
                <div style="position: relative;">
                    <img src="@/images/honeYou4.png" style="width: 38.49vw;height: 14.95vw;">
                    <div class="boxTwoCss">
                        <div class="boxTitleCss">针对性与个性化</div>
                        <div>
                            针对不同的个体和情况，我们提供量身定制的疗愈方案。<br> 通过专业评估，为每位客户推荐最适合的疗愈方式。
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="background-color: #FFF;text-align: center;padding-bottom:5.21vw;background: #f0f6fa">
            <div class="TitleCss" style="margin-bottom:1.56vw;padding-top:4.81vw;">
                <div style="margin-bottom:0.52vw;">
                    合作伙伴
                </div>
                <div style="font-weight: 400;font-size: 0.73vw;color: #7ED0FF;">
                    Partner
                </div>
            </div>
            <div class="box2Css" style="margin-left:13.49vw;margin-right:13.49vw">
                <img src="@/images/blackNoe.png"
                    style="width: 13.91vw;height: 5.36vw;margin-right:0.52vw;margin-bottom:1.04vw" v-for="item in 10"
                    :key="item">
            </div>
        </div>
    </div>
</template>

<script>
import swiperCom from "@/components/swiper.vue"
export default {
    name: 'homePage',
    components: {
        swiperCom
    },
    data() {
        return {

        }
    },
    methods: {
        toGO() {
            window.location.href = "https://www.foheart.cn";
        }
    }
}
</script>

<style lang="less" scoped>
.TitleCss {
    margin: 0 auto;
    text-align: center;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 1.88vw;
    color: #0093E8;
}

.jianxinCss {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 0.94vw;
    color: #666666;
    line-height: 1.88vw;
    margin-bottom: 5.21vw;
    flex-wrap: wrap;
    padding-bottom: 1.04vw;
}

.btn1 {
    width: 7.86vw;
    height: 3.13vw;
    background: #0093E8;
    border-radius: 1.56vw 1.56vw 1.56vw 1.56vw;
    text-align: center;
    line-height: 3.13vw;
    margin-top: 1.67vw;
    color: #fff;
    cursor: pointer;

    &:hover {
        background: #EBBAD5;
    }
}

.box2Css {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}

.boxOneCss {
    width: 19.74vw;
    height: 31.72vw;
    background: radial-gradient(#E3F5FF 0%, #FFF8F9 100%);
    box-shadow: 0.36vw 0px 1.51vw 0px #007BD9;
    border-radius: 1.04vw 1.04vw 1.04vw 1.04vw;
    border: 0.1vw solid #FFFFFF;
    display: flex;
    align-items: center;
    // justify-content: center;
    flex-direction: column;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 500;
    font-size: 1.35vw;
    color: #323232;
    margin-right: 1.04vw;
}

.boxOneText {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 0.83vw;
    color: #666666;
    line-height: 1.56vw;
    width: 13.33vw;
    text-align-last: left;
}

.topTitle {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 3.44vw;
    color: #FEFEFC;
    line-height: 7.29vw;
    text-align: justifyLeft;
    font-style: normal;
    text-transform: none;
    background: -webkit-linear-gradient(0deg, #41B9FF 0%, #0093E8 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    position: absolute;
    left: 21.15vw;
    top: 10.57vw;
}

.topText {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 1.46vw;
    color: #444444;
    line-height: 7.29vw;
    text-align: justifyLeft;
    font-style: normal;
    text-transform: none;
    position: absolute;
    left: 21.15vw;
    top: 15vw;
}

.boxTwoCss {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 500;
    font-size: 0.89vw;
    color: #666666;
    width: 23.91vw;
    position: absolute;
    left: 10.62vw;
    top: 3.91vw;
    text-align: left;
}

.boxTitleCss {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 600;
    font-size: 1.35vw;
    color: #323232;
    margin-bottom: 1.25vw;
}
</style>